<template>
  <v-layout column>

    <h2>ROTINA (pai, favor descrever brevemente)</h2>
    <h3 class="mb-2 text-secondary">ROUTINE (Dad, please describe briefly)</h3>

     <v-textarea
      outline
      v-model="resource.form.why_maplebear_from_father"
      label="POR QUE ESCOLHEU A MAPLE BEAR JARDINS? WHY HAVE YOU CHOSEN MAPLE BEAR JARDINS?"
      placeholder="POR QUE ESCOLHEU A MAPLE BEAR JARDINS? WHY HAVE YOU CHOSEN MAPLE BEAR JARDINS?"
    />

    <v-textarea
      outline
      v-model="resource.form.school_expectations_from_father"
      label="QUAIS AS EXPECTATIVAS COM RELAÇÃO À ESCOLA? WHAT ARE YOUR EXPECTATIONS OF MAPLE BEAR JARDINS?"
      placeholder="QUAIS AS EXPECTATIVAS COM RELAÇÃO À ESCOLA? WHAT ARE YOUR EXPECTATIONS OF MAPLE BEAR JARDINS?"
    />

    <v-textarea
      outline
      v-model="resource.form.child_description_from_father"
      label="DESCREVA BREVEMENTE SEU FILHO. DESCRIBE YOUR CHILD BRIEFLY."
      placeholder="DESCREVA BREVEMENTE SEU FILHO. DESCRIBE YOUR CHILD BRIEFLY."
    />

    <v-textarea
      outline
      v-model="resource.form.limit_tolerance_from_father"
      label="COMO SEU FILHO LIDA COM LIMITES? O QUE DEVE OU NÃO SER FEITO? DESCREVA UMA SITUAÇÃO ONDE VOCÊ INTRODUZ LIMITES A ELE, SUA AÇÃO E A REAÇÃO DELE. HOW DOES YOUR CHILD DEAL WITH LIMITS? WHAT SHOULD OR SHOULD NOT BE DONE? DESCRIBE A SITUATION WHERE YOU INTRODUCED LIMITS TO HIM/ HER AND TELL US ABOUT HIS/ HER REACTION."
      placeholder="COMO SEU FILHO LIDA COM LIMITES? O QUE DEVE OU NÃO SER FEITO? DESCREVA UMA SITUAÇÃO ONDE VOCÊ INTRODUZ LIMITES A ELE, SUA AÇÃO E A REAÇÃO DELE. HOW DOES YOUR CHILD DEAL WITH LIMITS? WHAT SHOULD OR SHOULD NOT BE DONE? DESCRIBE A SITUATION WHERE YOU INTRODUCED LIMITS TO HIM/ HER AND TELL US ABOUT HIS/ HER REACTION."
    />

    <v-textarea
      outline
      v-model="resource.form.violence_reaction_from_father"
      label="EM BRIGAS OU DISPUTAS, COMO SEU FILHO REAGE? E QUAL SUA INTERFERÊNCIA? IN FIGHTS OR DISPUTES, HOW DOES YOUR CHILD REACT AND HOW DO YOU HANDLE THE SITUATION?"
      placeholder="EM BRIGAS OU DISPUTAS, COMO SEU FILHO REAGE? E QUAL SUA INTERFERÊNCIA? IN FIGHTS OR DISPUTES, HOW DOES YOUR CHILD REACT AND HOW DO YOU HANDLE THE SITUATION?"
    />

    <v-textarea
      outline
      v-model="resource.form.mother_relationship_from_father"
      label="COMO É O RELACIONAMENTO ENTRE A CRIANÇA E A MÃE? HOW IS THE RELATIONSHIP BETWEEN THE CHILD AND HIS/HER MOM?"
      placeholder="COMO É O RELACIONAMENTO ENTRE A CRIANÇA E A MÃE? HOW IS THE RELATIONSHIP BETWEEN THE CHILD AND HIS/HER MOM?"
    />

    <v-textarea
      outline
      v-model="resource.form.father_relationship_from_father"
      label="COMO É O RELACIONAMENTO ENTRE A CRIANÇA E A PAI? HOW IS THE RELATIONSHIP BETWEEN THE CHILD AND HIS/HER DAD?"
      placeholder="COMO É O RELACIONAMENTO ENTRE A CRIANÇA E A PAI? HOW IS THE RELATIONSHIP BETWEEN THE CHILD AND HIS/HER DAD?"
    />

    <v-textarea
      outline
      v-model="resource.form.stranger_relationship_from_father"
      label="COMO SEU FILHO SEU RELACIONA COM ESTRANHOS? HOW DOES THE CHILD DEAL WITH STRANGERS?"
      placeholder="COMO SEU FILHO SEU RELACIONA COM ESTRANHOS? HOW DOES THE CHILD DEAL WITH STRANGERS?"
    />

  </v-layout>
</template>

<script>
/**
 * @group Form
 * Componente de form para dados da Rotina do Pai
 */
export default {
  name: 'FormFatherRoutine',

  data: () => ({
    emptyRule: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  inject: ['resource'],

  computed: {
    resource () {
      return this.resource
    }
  }
}
</script>
